import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'

/**
 * @typedef {Object} InputOutputEvent
 * @property {Id} [driverId] - The ID of the driver (if available)
 * @property {Id} [endAddressId] - The ID of the address of the end event
 * @property {LocationDescription} [endLocationDescription] - End location description (new TT Reverse Geocoder)
 * @property {Position} [endPosition] - The geo position of the end event (decimal degree)
 * @property {ISO8601} [endTime] - The end date of the event (ISO8601)
 * @property {Id} [ioId] - The ID of the input output event
 * @property {number} [ioIndex] - The index of the input output event
 * @property {string} [ioName] - The name of the input output event
 * @property {string} [ioType] - The type of the input output event
 * @property {Id} [objectId] - The ID of the object
 * @property {Id} [startAddressId] - The ID of the address of the start event
 * @property {LocationDescription} [startLocationDescription] - Start location description (new TT Reverse Geocoder)
 * @property {Position} [startPosition] - The geo position of the start event (decimal degree)
 * @property {ISO8601} [startTime] - The start date of the event (ISO8601)
 */
export const inputOutputEventPropType = PropTypes.shape({
    driverId: idPropType,
    endAddressId: idPropType,
    endLocationDescription: locationDescriptionPropType,
    endPosition: positionPropType,
    endTime: iso8601PropType,
    ioId: idPropType,
    ioIndex: PropTypes.number,
    ioName: PropTypes.string,
    ioType: PropTypes.string,
    objectId: idPropType,
    startAddressId: idPropType,
    startLocationDescription: locationDescriptionPropType,
    startPosition: positionPropType,
    startTime: iso8601PropType
})
